import { render, staticRenderFns } from "./PresetsList.vue?vue&type=template&id=0272920d&"
import script from "./PresetsList.vue?vue&type=script&lang=ts&"
export * from "./PresetsList.vue?vue&type=script&lang=ts&"
import style0 from "./PresetsList.vue?vue&type=style&index=0&id=0272920d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports